import { VestigingStatus } from "@/entities/vestiging";
import { LandelijkeFaciliteitenAanvraagDto } from "@/shared/types";

export type AangevraagdeLandelijkeFaciliteiten = {
    status: VestigingStatus;
    toelichting?: string;
};

export const AangevraagdeLandelijkeFaciliteiten = {
    fromDto: (dto: LandelijkeFaciliteitenAanvraagDto) => ({
        status: dto.status,
        toelichting: dto.toelichting,
    }),
};
